<ng-container *ngIf="initialized">
  <form class="form" (ngSubmit)="onSave()" [formGroup]="formGroup" novalidate>
    <div class="modal-content">
      <div class="modal-header d-flex justify-content-between">
        <h5 class="modal-title" id="exampleModalLabel">Edit CEU Assessment</h5>
        <button class="btn btn-sm btn-admin-primary" *ngIf="auth.isSuperUser()" (click)="ghostWrite()" type="button" [promiseBtn]="submitComplete2">Ghost Write</button>
      </div>

      <div class="modal-body" style="height: calc(100vh - 250px); overflow: scroll">
        <div class="row">
          <div class="col">
            <div *ngIf="errorMessage" class="alert alert-danger">
              {{ errorMessage }}
            </div>
            <div formArrayName="questions" *ngFor="let question of formGroup.controls.questions['controls']; let i = index" class="js-focus-state form-group">
              <div [formGroupName]="i">
                <div class="input-group input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      <span class="">Q</span>
                    </span>
                  </div>
                  <input type="text" formControlName="text" class="form-control" placeholder="Question Text" aria-label="Username" />
                  <div class="input-group-append">
                    <button type="button" class="btn btn-icon btn-danger transition-3d-hover" (click)="removeQuestion(i)">
                      <span class="fas fa-trash btn-icon__inner"></span>
                    </button>
                  </div>
                </div>

                <div formArrayName="answers" *ngFor="let answer of question.controls['answers'].controls; let j = index" class="ml-5 js-focus-state form-group">
                  <div [formGroupName]="j" class="input-group input-group">
                    <div class="input-group-prepend">
                      <button *ngIf="answer.controls['isCorrectResponse'].value" type="button" class="btn btn-icon btn-success transition-3d-hover" (click)="answer.controls['isCorrectResponse'].setValue(!answer.controls['isCorrectResponse'].value)">
                        <span class="fas fa-check btn-icon__inner"></span>
                      </button>
                      <button *ngIf="!answer.controls['isCorrectResponse'].value" type="button" class="btn btn-icon btn-outline-secondary transition-3d-hover" (click)="answer.controls['isCorrectResponse'].setValue(!answer.controls['isCorrectResponse'].value)">
                        <span class="far fa-square btn-icon__inner"></span>
                      </button>
                    </div>
                    <input type="text" formControlName="text" class="form-control" placeholder="Answer Text" aria-label="Username" />

                    <div class="input-group-append">
                      <button type="button" class="btn btn-icon btn-danger transition-3d-hover" (click)="removeAnswer(question, j)">
                        <span class="fas fa-trash btn-icon__inner"></span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="ml-4">
                  <a role="button" class="ml-5 text-primary cursor-pointer" (click)="addAnswer(question)">Add Answer</a>
                </div>
              </div>
            </div>
            <a role="button" class="text-primary cursor-pointer" (click)="addQuestion()">Add Question</a>
          </div>
        </div>
      </div>
      <div class="modal-footer justify-content-between" [ngClass]="{ 'alert-danger': errorMessage }">
        <div>
          {{ errorMessage }}
        </div>
        <div>
          <button class="btn btn-outline-dark mr-2" (click)="onCancel()" type="button">Cancel</button>
          <button class="btn btn-primary" [promiseBtn]="submitComplete" type="submit">Save</button>
        </div>
      </div>
    </div>
  </form>
</ng-container>
